import Header from '../Layout/Header'
//import Footer from '../Layout/Footer'
import { Container } from '@sainsburys-tech/luna-grid';
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components';
import IChildren from '../../Interfaces/IChildren'
import { RoleKey } from '../../Constants';
import Unauthorised from '../Unauthorised';
import { consolelog } from '../../Utils/consolelog';

const StyledContainer = styled(Container)`
  width: 95%;
  margin: ${({ haslandingimage }) =>
    haslandingimage === 'true' ? '0 auto 1rem auto' : '1rem auto'};
`;

const SiteLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const HeaderWrapper = styled.div`
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
`;

const BodyWrapper = styled.div`
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
`;

// const FooterWrapper = styled.div`
//   flex-basis: auto;
//   flex-grow: 0;
//   flex-shrink: 0;
// `;

// const buildStyle = {
//   textAlign: 'center',
// };


const Layout: FC<IChildren> = props => {
  const [isAccess, setIsAccess] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let roles: string[] = [];
  var val = sessionStorage.getItem(RoleKey.a85a8e6b348b4011a1ec1e78e9620782) || ""
  if(val!=="undefined"){
    roles = JSON.parse(val) as string[];
  }
  
  useEffect(() => {
    if (val!=="undefined" && (roles.indexOf(RoleKey.a85a8e6b348b4013a1ec1e78e9620782) > -1 || 
        roles.indexOf(RoleKey.a85a8e6b348b4023a1ec1e78e9620782) > -1 ||
        roles.indexOf(RoleKey.a85a8e6b348b4043a1ec1e78e9620782) > -1 )) {
      setIsAccess(true);
    }
  },[roles, val])

  return (
    <SiteLayout>
      {isAccess ? (<HeaderWrapper>
        <Header />
      </HeaderWrapper>) : <Unauthorised/>}
      {isAccess && <BodyWrapper>
        <StyledContainer >{consolelog('Hello', props.children)}
          {props.children}
        </StyledContainer>
      </BodyWrapper>}
      {/* <FooterWrapper>
        <div style={buildStyle}>Version @(BuildId)@-@(env)@</div>
        <Footer/>
      </FooterWrapper> */}
    </SiteLayout>
  );
}

export default Layout;